const name = "bookingForm";
const SET_BOOKING_FORM_DATA = `${name}/SET_BOOKING_FORM_DATA`;

export function bookingFormChanged({
  startDate,
  endDate,
  hotelSelector,
  filters,
  promoCodes,
  ADULT,
  CHILD,
  BABY,
  childrenCount,
  stayQueue,
}) {
  return dispatch => {
    dispatch({
      type: SET_BOOKING_FORM_DATA,
      startDate,
      endDate,
      hotelSelector,
      filters,
      promoCodes,
      ADULT,
      CHILD,
      BABY,
      childrenCount,
      stayQueue,
    });
  };
}

export const bookingFormActions = {
  bookingFormChanged,
};

export default (
  previousState = {
    _asyncValidating: false,
    _initialized: true,
    _submitting: false,
    _submitFailed: false,
    startDate: {},
    endDate: {},
    hotelSelector: {},
    filters: {},
    promoCodes: {},
    ADULT: {},
    CHILD: {},
    BABY: {},
    childrenCount: {},
    stayQueue: {},
  },
  action
) => {
  switch (action.type) {
    case SET_BOOKING_FORM_DATA:
      return {
        ...previousState,
        startDate: {
          ...previousState.startDate,
          value: action.startDate !== undefined ? action.startDate : previousState.startDate.value,
        },
        endDate: {
          ...previousState.endDate,
          value: action.endDate !== undefined ? action.endDate : previousState.endDate.value,
        },
        hotelSelector: {
          ...previousState.hotelSelector,
          value:
            action.hotelSelector !== undefined
              ? action.hotelSelector
              : previousState.hotelSelector.value,
        },
        filters: {
          ...previousState.filters,
          value: action.filters !== undefined ? action.filters : previousState.filters.value,
        },
        promoCodes: {
          ...previousState.promoCodes,
          value:
            action.promoCodes !== undefined ? action.promoCodes : previousState.promoCodes.value,
        },
        ADULT: {
          ...previousState.ADULT,
          value: action.ADULT !== undefined ? action.ADULT : previousState.ADULT.value,
        },
        CHILD: {
          ...previousState.CHILD,
          value: action.CHILD !== undefined ? action.CHILD : previousState.CHILD.value,
        },
        BABY: {
          ...previousState.BABY,
          value: action.BABY !== undefined ? action.BABY : previousState.BABY.value,
        },
        childrenCount: {
          ...previousState.childrenCount,
          value:
            action.childrenCount !== undefined
              ? action.childrenCount
              : previousState.childrenCount.value,
        },
        stayQueue: {
          ...previousState.stayQueue,
          value: action.stayQueue !== undefined ? action.stayQueue : previousState.stayQueue.value,
        },
      };
    default:
      return previousState;
  }
};
